import React, { useRef, useEffect } from "react";
import JoditEditor from "jodit-react";
import useBlogPost from "../../globalState/usePost";

type Props = {
  data: any;
};

export default function PostEditor({ data }: Props) {
  const editor = useRef(null);
  const { post, setPost } = useBlogPost();

  useEffect(() => {
    if (data) {
      setPost(data);
    } else {
      setPost("");
    }
  }, [setPost, data]);

  return (
    <JoditEditor
      ref={editor}
      value={post}
      // @ts-ignore
      tabIndex={1}
      onChange={(newContent) => {
        setPost(newContent);
      }}
    />
  );
}
